import { CalculationSchema } from "src/features/calculator/schema"
import dayjs from "dayjs"

const comma = (n: number | null): string => (n === null ? "0" : n.toLocaleString())
const round = (num: number, k: number = 3) => Math.round(num * 10 ** k) / 10 ** k

export function makeSpreadSheetColumnsText(values: CalculationSchema): string {
  const {
    applicationId,
    userId,
    userName,
    storeId,
    storeName,
    scheduledDealAt,
    paymentMethod,
    strategy,
    initialCost,
    rent,
    customerTransferFeeRate,
    totalReimbursement,
    customerTransferFee,
    customerTransferFeeResult,
    remittanceResult,
    customerTransferFeeRateResult,
    totalReimbursementResult,
  } = values

  const totalReimbursementValue = totalReimbursementResult ?? totalReimbursement ?? ""

  const data = {
    加盟店種別: strategy,
    ユーザーID: userId,
    ユーザー名: userName,
    加盟店ID: storeId,
    加盟店名: storeName,
    立替申請ID: applicationId,
    支払い方式: paymentMethod,
    初期費用総額: initialCost ?? "",
    分割対象額: totalReimbursementValue,
    "手数料（税込）": customerTransferFeeResult ?? customerTransferFee ?? "",
    "送客手数料率(税込)": customerTransferFeeRateResult ?? customerTransferFeeRate ?? "",
    家賃: rent ?? "",
    相殺有無: remittanceResult === totalReimbursementValue ? "無" : "有",
    送金額: remittanceResult ?? "",
    計算式確認: location.href,
    立替日: dayjs(scheduledDealAt)?.format("YYYY/MM/DD"),
  }

  const columns = [
    "ユーザーID",
    "ユーザー名",
    "加盟店ID",
    "加盟店名",
    "社名",
    "賃貸契約締結日",
    "初期費用総額",
    "分割対象額",
    "手数料（税込）",
    "家賃",
    "相殺有無",
    "送金額",
    "",
    "立替日",
    ...Array(18).map(() => ""),
    "計算式確認",
    "",
    "立替申請ID",
    "支払い方式",
    "送客手数料率(税込)",
  ]
  return columns.map((key) => `${data?.[key as keyof typeof data] ?? ""}`).join("	")
}

export function toLineText(values: CalculationSchema): string {
  const {
    applicationId,
    initialCost,
    rent,
    customerTransferFee,
    customerTransferFeeRate,
    totalReimbursement,
    customerTransferFeeResult,
    remittanceResult,
    selfPaymentResult,
    totalReimbursementResult,
    customerTransferFeeRateResult,
  } = values

  const customerTransferFeeValue = customerTransferFeeResult ?? customerTransferFee

  let text = `お世話になっております。\n`
  text += `初期費用の立替送金に関してのご連絡となります。\n`

  if (selfPaymentResult > 0) {
    text += `お客様から${comma(
      selfPaymentResult
    )}円を貴社にお振り込みいただくよう、ご依頼くださいませ。\n`
  }

  text += `\n`

  text += `▼「賃貸借契約書への署名/捺印」が完了次第、
該当のお客様の管理画面上にてご契約日のご登録をお願いいたします。
（※すでにご対応済みの場合はご放念くださいませ。）
＿＿＿＿＿\n\n`

  text += `■ご注意点\n・お客様への下記内訳の共有はお控えくださいませ。\n`

  text += `\n`
  // text += `【ご送金先：${加盟店名}】\n`
  text += `▼ご送金明細\n`
  text += `お客様情報： https://partner.smooth.jp/applications/${applicationId}/payment-application\n`
  text += `初期費用総額： ¥${comma(initialCost)}\n`
  text += `立替元本: ¥${comma(totalReimbursementResult ?? totalReimbursement)}\n`
  text += `家賃： ¥${comma(rent)}\n`
  text += `手数料率(税込)： ${customerTransferFeeRateResult ?? customerTransferFeeRate}\n`
  text += `手数料（税抜）： ¥${comma(round((customerTransferFeeValue / 11) * 10, 0))}\n`
  text += `手数料（税込）： ¥${comma(customerTransferFeeValue)}\n`
  text += `ご送金額： ¥${comma(remittanceResult)}\n`
  text += `お客様にお支払いいただく金額：　¥${comma(selfPaymentResult)}`

  return text
}
